/**
 * DevExtreme (esm/data/query_implementation.js)
 * Version: 23.2.3
 * Build date: Tue Nov 28 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import arrayQueryImpl from "./array_query";
import remoteQueryImpl from "./remote_query";
export var queryImpl = {
    array: arrayQueryImpl,
    remote: remoteQueryImpl
};
